import React from 'react';
import { Heart, BookOpen, Mail, Twitter, Github } from 'lucide-react';
import { FooterProps } from '../types';
import './Footer.css';

const Footer: React.FC<FooterProps> = ({ className = '' }) => {
  const currentYear: number = new Date().getFullYear();

  return (
    <footer className={`site-footer ${className}`}>
      <div className="footer-container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-section brand">
            <div className="flex">
              <BookOpen size={24} className='me-3'/>
              <span>Echoes Of Lunaria</span>
            </div>
            <p className="footer-description">
              A dark fantasy tale of a shattered moon, cursed ruins, and the silent wanderer bound to its buried truth.

              
            </p>
            <div className="flex gap-3">
              <a href="#" className="social-link" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="#" className="social-link" aria-label="GitHub">
                <Github size={20} />
              </a>
              <a href="#" className="social-link" aria-label="Email">
                <Mail size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section links">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/chapters">All Chapters</a></li>
              <li><a href="/profile">Profile</a></li>
            </ul>
          </div>

          

          {/* Contact */}
          <div className="footer-section contact">
            <h3>Contact</h3>
            <ul>
              <li><a href="/contact">Feedback</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} Echoes Of Lunaria. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <a href="/terms-of-service">Terms And Conditions</a>
              <span> | </span>
              <a href="/cookie-policy">Cookie Policy</a>
              <span> | </span>
              <a href="/refund-policy">Refund & Cancellation Policy</a>
            </div>
          </div>
          <div className="footer-heart">
            <div className='flex gap-3 justify-center'>
              <span>Made with</span>
              <Heart size={16} fill="currentColor" className='mt-1'/>
            </div>
            <span>for fantasy lovers</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;